import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import WithFormField from "components/Form/WithFormField";

import { ConfirmationDropdown } from "scenes/Hubly/components/Workspace/components/Assigner/components/UserSelector/components";

import { useGetUsersOptions } from "./hooks";

export function AccountOwnerSelector({
  accountOwnerId,
  name,
  required,
  ...props
}) {
  const { loading, users, error } = useGetUsersOptions();

  const { field } = useController({
    name: name,
    defaultValue: accountOwnerId,
    rules: { required: required },
  });

  if (error) {
    return <div>{error}</div>;
  }

  if (loading) {
    return (
      <ConfirmationDropdown
        loading
        searchInput={{ autoFocus: false }}
        disabled
        initValue=""
        showSaveButton={false}
        onSelect={() => {}}
        data-test="loading-account-owner-selector"
        {...props}
      />
    );
  }

  return (
    <ConfirmationDropdown
      key="account-owner-selector"
      data-test="account-owner-selector"
      loading={loading}
      initValue={
        users?.find(({ key }) => {
          return key === accountOwnerId;
        })?.key
      }
      onSelect={field.onChange}
      items={users}
      showSaveButton={false}
      searchInput={{ autoFocus: false }}
      {...props}
    />
  );
}

AccountOwnerSelector.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  accountOwnerId: PropTypes.string,
};

AccountOwnerSelector.defaultProps = { required: true, accountOwnerId: "" };

export default WithFormField(AccountOwnerSelector);
